import { useCookies } from "@magalu/rave/router";
import Router from "next/router";

import buildNextRedirectUrl from "@utils/buildNextRedirectUrl";
import {
  COOKIE_CUSTOMER_INFO,
  COOKIE_CUSTOMER_SESSION_ID,
} from "@utils/constants/cookies";
import getNationalUrlByDevice from "@utils/getNationalUrlByDevice";
import { ClientEnvType } from "@utils/types/clientEnv.types";

type PropsType = {
  redirect: {
    destination: string;
    permanent: boolean;
  };
};

const checkLogin = async (
  _ctx: unknown,
  _props: PropsType,
  args: { clientConfig: ClientEnvType },
  done: () => void
) => {
  const { getCookie } = useCookies(undefined);
  const {
    clientConfig: { environment, nationalUrls },
  } = args;
  const { pathname } = Router;
  const url = getNationalUrlByDevice(nationalUrls);

  const customerSessionId =
    (getCookie(COOKIE_CUSTOMER_SESSION_ID) as string) || "";
  const customerCookieInfo = (getCookie(COOKIE_CUSTOMER_INFO) as string) || "";

  const hostUrl = buildNextRedirectUrl(environment, pathname);
  if (customerSessionId?.length === 0 || customerCookieInfo?.length === 0) {
    _props.redirect = {
      destination: `${url}/#/cliente/login/?next=${hostUrl}`,
      permanent: false,
    };
    return;
  }

  return done();
};

export default checkLogin;
